// extracted by mini-css-extract-plugin
export default {"heading_text":"events_list_heading_text__fjcji"};